<div class="a00080">
    <span [inlineSVG]="'/icons/toTop.svg'"></span>
</div>
